/* Find My Size runtime */
  (function () {
    document.body.classList.add('template-find-your-fit');
    var section = document.currentScript.previousElementSibling;
    while (section && !section.hasAttribute('data-find-my-size-config')) {
      section = section.previousElementSibling;
    }
    if (!section) return;

    var wrapper = section.previousElementSibling;
    while (wrapper && !wrapper.hasAttribute('data-find-my-size-section')) {
      wrapper = wrapper.previousElementSibling;
    }
    if (!wrapper) return;

    var config = {};
    try {
      config = JSON.parse(section.textContent || '{}');
    } catch (error) {
      config = {};
    }

    var app = wrapper.querySelector('[data-find-my-size-app]');
    var select = wrapper.querySelector('[data-size-select]');
    var selectWrap = wrapper.querySelector('.find-my-size-page__select-wrap');
    var summary = wrapper.querySelector('[data-size-summary]');
    var resetButton = wrapper.querySelector('[data-size-reset]');
    var shareButton = wrapper.querySelector('[data-size-share]');
    var keywordWrap = wrapper.querySelector('[data-keyword-wrap]');
    var keywordInput = wrapper.querySelector('[data-keyword-search]');
    var keywordClear = wrapper.querySelector('[data-keyword-clear]');
    var guide = wrapper.querySelector('[data-size-guide]');
    var guideToggle = wrapper.querySelector('[data-size-guide-toggle]');
    var status = wrapper.querySelector('[data-status]');
    var results = wrapper.querySelector('[data-results]');
    if (!app || !select || !status || !results) return;

    var moneyFormat = null;
    var pageSize = parseInt(config.pageSize, 10) || 250;
    var requestTimeoutMs = 7000;
    var productCacheTtlMs = 5 * 60 * 1000;
    var hydrationConcurrency = 4;
    var initialHydrationItemLimit = 16;
    var shareButtonResetTimer = null;
    var state = {
      sizes: [],
      itemsBySize: {},
      loaded: false,
      selectedSize: '',
      keywordQuery: '',
      queryFeedback: [],
      productDetailsCache: {},
      productPageHtmlCache: {},
      productPageDataCache: {},
      productInventoryCache: {},
      hydrationRunId: 0
    };

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(new RegExp(String.fromCharCode(60), 'g'), '&lt;')
        .replace(new RegExp(String.fromCharCode(62), 'g'), '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }

    // The card image comes from the index view at a single 360px width, so on a 2x phone - where a
    // ~180px card wants 360-540px of pixels - it rendered soft, and a wider card got the same file.
    // The CDN accepts a width parameter, so the responsive set is derived from the URL already
    // returned: no extra payload. Returns '' when the URL carries no width token, in which case the
    // plain src is used exactly as before.
    function buildSrcset(imageUrl) {
      var url = String(imageUrl || '');
      if (!url) return '';
      var widths = [360, 540, 720];
      var parts = [];
      for (var i = 0; i < widths.length; i++) {
        var candidate = url
          .replace(/([?&]width=)\d+/, '$1' + widths[i])
          .replace(/_(\d+)x(?=\.|$)/, '_' + widths[i] + 'x');
        parts.push(candidate + ' ' + widths[i] + 'w');
      }
      // The 360 candidate equals the input when the URL already carries width=360, so comparing the
      // first candidate would wrongly conclude "no width token" and emit nothing. Compare the widest.
      return parts[2].split(' ')[0] === url ? '' : parts.join(', ');
    }
    function srcsetAttribute(imageUrl) {
      var set = buildSrcset(imageUrl);
      if (!set) return '';
      return ' srcset="' + escapeHtml(set) + '" sizes="(min-width: 1000px) 25vw, (min-width: 760px) 33vw, 50vw"';
    }
    function resizeImageUrl(imageUrl, size) {
      if (!imageUrl) return '';

      if (window.Shopify && typeof window.Shopify.resizeImage === 'function') {
        try {
          return window.Shopify.resizeImage(imageUrl, size || '600x');
        } catch (error) {}
      }

      return imageUrl;
    }

    function normalizeMoneyCents(value) {
      if (value == null || value === '') return null;

      if (typeof value === 'string' && value.indexOf('.') !== -1) {
        return Math.round(parseFloat(value) * 100);
      }

      return parseInt(value, 10);
    }

    function buildCollectionUrl(page) {
      var handle = (config.collectionHandle || '').replace(/^\/+|\/+$/g, '');
      var path = (config.collectionPath || '').replace(/\/$/, '');
      var base = handle ? '/collections/' + handle : path;
      if (!base) return '';
      return base + '/products.json?limit=' + pageSize + '&page=' + page;
    }

    function buildCollectionIndexUrl(page) {
      var handle = (config.collectionHandle || '').replace(/^\/+|\/+$/g, '');
      var path = (config.collectionPath || '').replace(/\/$/, '');
      var base = handle ? '/collections/' + handle : path;
      if (!base) return '';
      return base + '?view=find-my-size-index&page=' + page;
    }

    function getProductsCacheKey() {
      var handle = (config.collectionHandle || '').replace(/^\/+|\/+$/g, '');
      var path = (config.collectionPath || '').replace(/\/$/, '');
      return 'findMySizeProducts:v2:' + (handle || path || 'default') + ':' + pageSize;
    }

    function readCachedProducts() {
      if (!window.sessionStorage) return null;

      try {
        var cached = JSON.parse(window.sessionStorage.getItem(getProductsCacheKey()) || 'null');
        if (!cached || !cached.timestamp || !cached.products) return null;
        if (Date.now() - cached.timestamp > productCacheTtlMs) return null;
        return cached.products;
      } catch (error) {
        return null;
      }
    }

    function writeCachedProducts(products) {
      if (!window.sessionStorage || !products || !products.length) return;

      try {
        window.sessionStorage.setItem(getProductsCacheKey(), JSON.stringify({
          timestamp: Date.now(),
          products: products
        }));
      } catch (error) {}
    }

    function normalizeSize(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, '')
        .toUpperCase();
    }

    function prettifySize(value) {
      var text = String(value || '').trim();
      if (!text) return '';
      return text.replace(/\s*\/\s*/g, '/').replace(/\s*\(/g, ' (').toUpperCase();
    }

    function tokenizeSearch(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .split(/\s+/)
        .filter(Boolean);
    }

    function getDisplayKeywordQuery() {
      return String(state.keywordQuery || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getActiveKeywords() {
      return tokenizeSearch(state.keywordQuery);
    }

    function updateHeaderSummary(sizeKey, count) {
      if (!summary) return;

      if (!sizeKey) {
        summary.hidden = true;
        summary.textContent = '';
        return;
      }

      summary.hidden = false;
      summary.textContent = 'Showing ' + count + ' styles in Size ' + prettifySize(sizeKey);
    }

    function setGuideExpanded(isExpanded, shouldScroll) {
      if (!guide || !guideToggle) return;

      guide.hidden = !isExpanded;
      guideToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      guideToggle.textContent = isExpanded ? 'Hide Crocs size guide' : 'View Crocs size guide';

      if (isExpanded && shouldScroll && typeof guide.scrollIntoView === 'function') {
        guide.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function updateGuideForSelection() {
      if (!guide || !guideToggle) return;
      setGuideExpanded(!state.selectedSize, false);
    }

    function itemMatchesKeywords(item, keywords) {
      if (!keywords || !keywords.length) return true;

      var haystack = tokenizeSearch(item && item.title ? item.title : '').join(' ');
      if (!haystack) return false;

      for (var i = 0; i < keywords.length; i += 1) {
        if (haystack.indexOf(keywords[i]) === -1) return false;
      }

      return true;
    }

    function isLikelySizeValue(value) {
      var normalized = normalizeSize(value);
      if (!normalized) return false;
      if (/^M\d+(\.\d+)?\/W\d+(\.\d+)?$/.test(normalized)) return true;
      if (/^(C|J|M|W)\d+(\.\d+)?$/.test(normalized)) return true;
      if (/^(US|UK|EU)\s*[\d.]+$/i.test(value || '')) return true;
      if (/^\d+(\.\d+)?$/.test(normalized)) return true;
      return false;
    }

    function getOptionName(option) {
      if (typeof option === 'string') return option;
      if (option && typeof option.name === 'string') return option.name;
      return '';
    }

    function getVariantOptionValue(variant, index) {
      if (!variant) return '';
      if (variant['option' + index] != null) return variant['option' + index];
      if (variant.options && variant.options[index - 1] != null) return variant.options[index - 1];
      return '';
    }

    function getOptionCount(product) {
      var count = product && product.options ? product.options.length : 0;
      if (count) return count;

      var variants = (product && product.variants) || [];
      for (var index = 1; index <= 3; index += 1) {
        for (var v = 0; v < variants.length; v += 1) {
          if (getVariantOptionValue(variants[v], index)) return index;
        }
      }

      return 0;
    }

    function getSizeOptionIndexes(product) {
      var indexes = [];
      var options = product.options || [];
      for (var i = 0; i < options.length; i += 1) {
        if (/size/i.test(getOptionName(options[i]))) indexes.push(i + 1);
      }

      if (indexes.length) return indexes;

      var variants = product.variants || [];
      var optionCount = Math.max(getOptionCount(product), 3);
      for (var index = 1; index <= optionCount; index += 1) {
        for (var v = 0; v < variants.length; v += 1) {
          var optionValue = getVariantOptionValue(variants[v], index);
          if (isLikelySizeValue(optionValue)) {
            indexes.push(index);
            break;
          }
        }
      }

      if (!indexes.length && options.length === 1) indexes.push(1);
      return indexes;
    }

    function getColorLabel(product, variant, sizeIndexes) {
      var colors = [];
      var optionCount = getOptionCount(product);
      for (var index = 1; index <= optionCount; index += 1) {
        if (sizeIndexes.indexOf(index) !== -1) continue;
        var value = getVariantOptionValue(variant, index);
        if (!value || /default title/i.test(value)) continue;
        colors.push(value);
      }
      if (!colors.length && product.product_type) return product.product_type;
      return colors.join(' / ');
    }

    function getImage(product, variant) {
      if (variant && variant.featured_image) {
        if (variant.featured_image.src) return resizeImageUrl(variant.featured_image.src, '360x');
        if (typeof variant.featured_image === 'string') return resizeImageUrl(variant.featured_image, '360x');
      }
      if (product.image && product.image.src) return resizeImageUrl(product.image.src, '360x');
      if (product.images && product.images.length) return resizeImageUrl(product.images[0].src || product.images[0], '360x');
      return '';
    }

    function getProductUrl(product, variantId) {
      var url = product.handle ? '/products/' + product.handle : '#';
      if (variantId) return url + '?variant=' + variantId;
      return url;
    }

    function getProductJsonUrl(handle) {
      if (!handle) return '';
      return '/products/' + handle + '.js';
    }

    function fetchWithTimeout(url, options, timeoutMs) {
      if (!url) return Promise.reject(new Error('Missing URL'));

      var controller = window.AbortController ? new AbortController() : null;
      var timer = null;
      var requestOptions = options || {};

      if (controller) {
        requestOptions.signal = controller.signal;
      }

      timer = window.setTimeout(function () {
        if (controller) controller.abort();
      }, timeoutMs || requestTimeoutMs);

      return fetch(url, requestOptions).finally(function () {
        window.clearTimeout(timer);
      });
    }

    function fetchProductDetails(handle) {
      if (!handle) return Promise.resolve(null);
      var cachedProductDetails = state.productDetailsCache[handle];
      if (cachedProductDetails) {
        if (typeof cachedProductDetails.then === 'function') return cachedProductDetails;
        return Promise.resolve(cachedProductDetails);
      }

      state.productDetailsCache[handle] = fetchWithTimeout(getProductJsonUrl(handle), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.json();
        })
        .then(function (productDetails) {
          state.productDetailsCache[handle] = productDetails;
          return productDetails;
        })
        .catch(function () {
          state.productDetailsCache[handle] = null;
          return null;
        });

      return state.productDetailsCache[handle];
    }

    function fetchProductPageHtml(handle) {
      if (!handle) return Promise.resolve('');
      var cachedProductPageHtml = state.productPageHtmlCache[handle];
      if (cachedProductPageHtml) {
        if (typeof cachedProductPageHtml.then === 'function') return cachedProductPageHtml;
        return Promise.resolve(cachedProductPageHtml);
      }

      state.productPageHtmlCache[handle] = fetchWithTimeout('/products/' + handle, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.text();
        })
        .then(function (html) {
          state.productPageHtmlCache[handle] = html;
          return html;
        })
        .catch(function () {
          state.productPageHtmlCache[handle] = '';
          return '';
        });

      return state.productPageHtmlCache[handle];
    }

    function fetchProductPageData(handle) {
      if (!handle) return Promise.resolve(null);
      var cachedProductPageData = state.productPageDataCache[handle];
      if (cachedProductPageData) {
        if (typeof cachedProductPageData.then === 'function') return cachedProductPageData;
        return Promise.resolve(cachedProductPageData);
      }

      state.productPageDataCache[handle] = fetchProductPageHtml(handle)
        .then(function (html) {
          var match = html.match(/var\s+productVariantData\s*=\s*({[\s\S]*?});/);
          if (!match || !match[1]) return null;

          try {
            var productPageData = JSON.parse(match[1]);
            state.productPageDataCache[handle] = productPageData;
            return productPageData;
          } catch (error) {
            state.productPageDataCache[handle] = null;
            return null;
          }
        })
        .catch(function () {
          state.productPageDataCache[handle] = null;
          return null;
        });

      return state.productPageDataCache[handle];
    }

    function fetchProductInventoryData(handle) {
      if (!handle) return Promise.resolve(null);
      var cachedProductInventory = state.productInventoryCache[handle];
      if (cachedProductInventory) {
        if (typeof cachedProductInventory.then === 'function') return cachedProductInventory;
        return Promise.resolve(cachedProductInventory);
      }

      state.productInventoryCache[handle] = fetchProductPageHtml(handle)
        .then(function (html) {
          var match = html.match(/var\s+GPOProduct\s*=\s*({[\s\S]*?});/);
          if (!match || !match[1]) return null;

          var productInventoryData = parseScriptObjectLiteral(match[1]);
          if (!productInventoryData) {
            state.productInventoryCache[handle] = null;
            return null;
          }

          state.productInventoryCache[handle] = productInventoryData;
          return productInventoryData;
        })
        .catch(function () {
          state.productInventoryCache[handle] = null;
          return null;
        });

      return state.productInventoryCache[handle];
    }

    function findVariantById(productDetails, variantId) {
      var variants = productDetails && productDetails.variants ? productDetails.variants : [];
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(variantId)) return variants[i];
      }
      return null;
    }

    function parseScriptObjectLiteral(source) {
      if (!source) return null;

      try {
        return (new Function('return (' + source + ');'))();
      } catch (error) {
        return null;
      }
    }

    function mergeVariantData(baseVariant, fullVariant) {
      if (!baseVariant && !fullVariant) return null;
      if (!baseVariant) return fullVariant;
      if (!fullVariant) return baseVariant;

      var merged = {};
      var key;

      for (key in baseVariant) {
        if (baseVariant.hasOwnProperty(key)) merged[key] = baseVariant[key];
      }

      for (key in fullVariant) {
        if (fullVariant.hasOwnProperty(key)) merged[key] = fullVariant[key];
      }

      return merged;
    }

    function applyInventoryMapToVariant(variant, inventoryData) {
      if (!variant || !inventoryData || !inventoryData.product || !inventoryData.product.variants) return variant;

      var inventoryVariant = inventoryData.product.variants[String(variant.id)];
      if (!inventoryVariant) return variant;

      return mergeVariantData(variant, {
        inventory_management: inventoryVariant.inventory_management,
        inventory_policy: inventoryVariant.inventory_policy,
        inventory_quantity: inventoryVariant.inventory_quantity
      });
    }

    function getGpoPreorderVariant(productId, variantId) {
      var gpoProducts = window.GPOParams && window.GPOParams.products;
      if (!gpoProducts || productId == null || variantId == null) return null;

      var productEntry = gpoProducts[String(productId)];
      if (!productEntry || !productEntry.variants) return null;

      return productEntry.variants[String(variantId)] || null;
    }

    function isPreorderVariant(product, variant) {
      if (!variant) return false;

      var inventoryPreorder = !!(
        variant.available &&
        variant.inventory_management &&
        variant.inventory_policy === 'continue' &&
        typeof variant.inventory_quantity !== 'undefined' &&
        parseInt(variant.inventory_quantity, 10) <= 0
      );

      if (inventoryPreorder) return true;

      var gpoVariant = getGpoPreorderVariant(product && product.id, variant.id);
      return !!(
        variant.available &&
        gpoVariant &&
        String(gpoVariant.status) === '1'
      );
    }

    function isPurchasableVariant(product, variant) {
      if (!variant) return false;
      return !!(variant.available || isPreorderVariant(product, variant));
    }

    function runWithConcurrency(items, limit, worker) {
      var queue = items.slice();
      var workers = [];
      var workerCount = Math.min(Math.max(parseInt(limit, 10) || 1, 1), queue.length);

      function next() {
        var item = queue.shift();
        if (!item) return Promise.resolve();

        return worker(item).catch(function () {
          return null;
        }).then(next);
      }

      for (var index = 0; index < workerCount; index += 1) {
        workers.push(next());
      }

      return Promise.all(workers);
    }

    // Hydration exists for the products.json fallback, which carries no inventory fields: it reads them
    // from each product's own page. The compact index (collection.find-my-size-index) already includes
    // inventory_management / _policy / _quantity and marks its products inventory_known, so its items are
    // complete as collected and are skipped here - picking a size then costs no extra requests at all,
    // where it used to cost two per style: product.js plus the full product page.
    function hydrateItemsForDisplay(items) {
      var uniqueHandles = {};

      items = items.filter(function (item) { return item && !item.inventoryKnown; });

      items.forEach(function (item) {
        if (item && item.handle) uniqueHandles[item.handle] = true;
      });

      var handles = Object.keys(uniqueHandles);
      if (!handles.length) return Promise.resolve(items);

      return runWithConcurrency(handles, hydrationConcurrency, function (handle) {
        return Promise.all([
          fetchProductDetails(handle),
          fetchProductPageData(handle),
          fetchProductInventoryData(handle)
        ]);
      }).then(function () {
        return items.map(function (item) {
          var productDetails = state.productDetailsCache[item.handle];
          var productPageData = state.productPageDataCache[item.handle];
          var productInventoryData = state.productInventoryCache[item.handle];
          var jsonVariant = findVariantById(productDetails, item.variantId);
          var pageVariant = findVariantById(productPageData, item.variantId);
          var fullVariant = mergeVariantData(jsonVariant, pageVariant);
          fullVariant = applyInventoryMapToVariant(fullVariant, productInventoryData);

          if (!fullVariant) return item;

          var fullProduct = {
            id: (productPageData && productPageData.id) || (productDetails && productDetails.id) || item.productId,
            handle: (productPageData && productPageData.handle) || (productDetails && productDetails.handle) || item.handle
          };

          return {
            productId: item.productId,
            variantId: item.variantId,
            title: (productPageData && productPageData.title) || (productDetails && productDetails.title) || item.title,
            handle: item.handle,
            url: item.url,
            image: item.image,
            price: typeof fullVariant.price !== 'undefined' ? normalizeMoneyCents(fullVariant.price) : item.price,
            compareAtPrice: typeof fullVariant.compare_at_price !== 'undefined' ? normalizeMoneyCents(fullVariant.compare_at_price) : item.compareAtPrice,
            color: item.color,
            variantTitle: fullVariant.title || item.variantTitle,
            size: item.size,
            isPreorder: isPreorderVariant(fullProduct, fullVariant)
          };
        });
      });
    }

    function collectItems(products) {
      products.forEach(function (product) {
        var sizeIndexes = getSizeOptionIndexes(product);
        if (!sizeIndexes.length) return;

        (product.variants || []).forEach(function (variant) {
          if (!isPurchasableVariant(product, variant)) return;

          sizeIndexes.forEach(function (sizeIndex) {
            var rawSize = getVariantOptionValue(variant, sizeIndex);
            if (!rawSize || /default title/i.test(rawSize)) return;

            var normalizedSize = normalizeSize(rawSize);
            if (!normalizedSize) return;

            if (!state.itemsBySize[normalizedSize]) state.itemsBySize[normalizedSize] = [];
            if (state.sizes.indexOf(normalizedSize) === -1) state.sizes.push(normalizedSize);

            state.itemsBySize[normalizedSize].push({
              productId: product.id,
              variantId: variant.id,
              title: product.title,
              handle: product.handle,
              url: getProductUrl(product, variant.id),
              image: getImage(product, variant),
              price: normalizeMoneyCents(variant.price),
              compareAtPrice: normalizeMoneyCents(variant.compare_at_price),
              color: getColorLabel(product, variant, sizeIndexes) || (product.product_type || ''),
              variantTitle: variant.title,
              size: prettifySize(rawSize),
              isPreorder: isPreorderVariant(product, variant),
              inventoryKnown: !!product.inventory_known
            });
          });
        });
      });

      state.sizes.sort(function (a, b) {
        return prettifySize(a).localeCompare(prettifySize(b), undefined, { numeric: true, sensitivity: 'base' });
      });

      Object.keys(state.itemsBySize).forEach(function (sizeKey) {
        var seen = {};
        state.itemsBySize[sizeKey] = state.itemsBySize[sizeKey].filter(function (item) {
          var key = item.variantId;
          if (seen[key]) return false;
          seen[key] = true;
          return true;
        });
      });
    }

    function renderSizeOptions() {
      var options = ['<option value="">Select your size</option>'];
      state.sizes.forEach(function (size) {
        options.push('<option value="' + escapeHtml(size) + '">' + escapeHtml(prettifySize(size)) + '</option>');
      });
      select.innerHTML = options.join('');
      select.disabled = state.sizes.length === 0;
    }

    function updateQueryParam(sizeKey, keywordQuery) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (sizeKey) {
          url.searchParams.set('size', sizeKey);
        } else {
          url.searchParams.delete('size');
        }
        var activeQuery = String(keywordQuery || '').trim();
        if (activeQuery && sizeKey) {
          url.searchParams.set('query', activeQuery);
        } else {
          url.searchParams.delete('query');
        }
        window.history.replaceState({}, '', url.toString());
      } catch (error) {}
    }

    function getShareUrl(sizeKey, keywordQuery) {
      try {
        var url = new URL(window.location.href);
        if (sizeKey) {
          url.searchParams.set('size', sizeKey);
        } else {
          url.searchParams.delete('size');
        }
        var activeQuery = String(keywordQuery || '').trim();
        if (activeQuery && sizeKey) {
          url.searchParams.set('query', activeQuery);
        } else {
          url.searchParams.delete('query');
        }
        return url.toString();
      } catch (error) {
        return window.location.href;
      }
    }

    function setShareButtonState(copied) {
      if (!shareButton) return;

      var defaultLabel = shareButton.getAttribute('data-default-label') || 'Copy share link';
      shareButton.textContent = copied ? 'Copied' : defaultLabel;
      shareButton.classList.toggle('is-copied', !!copied);

      if (shareButtonResetTimer) {
        window.clearTimeout(shareButtonResetTimer);
        shareButtonResetTimer = null;
      }

      if (copied) {
        shareButtonResetTimer = window.setTimeout(function () {
          shareButton.textContent = defaultLabel;
          shareButton.classList.remove('is-copied');
          shareButtonResetTimer = null;
        }, 2200);
      }
    }

    function applyQueryParams() {
      var selectedFromQuery = '';
      var keywordFromQuery = '';
      state.queryFeedback = [];

      try {
        var url = new URL(window.location.href);
        var rawSize = url.searchParams.get('size');
        keywordFromQuery = url.searchParams.get('query') || '';
        if (rawSize) {
          var normalizedSize = normalizeSize(rawSize);
          // Size options carry an EU range, e.g. "M7/W9 (39-40)", so a link may name the full value or just
          // the Crocs code ("M7/W9", as the home page size buttons do). Exact match first, then by code.
          var sizeCode = function (key) { return String(key || '').replace(/\(.*$/, ''); };
          if (normalizedSize && !state.itemsBySize[normalizedSize]) {
            state.sizes.some(function (key) {
              if (sizeCode(key) !== sizeCode(normalizedSize)) return false;
              normalizedSize = key;
              return true;
            });
          }
          if (normalizedSize && state.itemsBySize[normalizedSize]) {
            selectedFromQuery = normalizedSize;
          } else {
            state.queryFeedback.push('Nothing in size ' + prettifySize(rawSize) + ' is available right now. Pick another size above.');
          }
        }
      } catch (error) {}

      if (keywordFromQuery) {
        setKeywordState(keywordFromQuery);
      }

      if (selectedFromQuery) {
        select.value = selectedFromQuery;
        setSelectedSize(selectedFromQuery);
        renderItems(selectedFromQuery);
      }

      if (state.queryFeedback.length) {
        status.textContent = state.queryFeedback.join(' ');
      }
    }

    function setKeywordState(value) {
      state.keywordQuery = String(value || '');

      if (keywordInput && keywordInput.value !== state.keywordQuery) {
        keywordInput.value = state.keywordQuery;
      }

      if (keywordClear) {
        keywordClear.hidden = !getActiveKeywords().length;
      }

      updateQueryParam(state.selectedSize, state.keywordQuery);
    }

    function renderStatusMarkup(sizeKey, filteredCount, totalCount) {
      var prettySize = prettifySize(sizeKey);
      var displayKeywordQuery = getDisplayKeywordQuery();
      var hasKeyword = !!displayKeywordQuery;

      if (hasKeyword) {
        return '<span class="find-my-size-page__status-line">' +
          '<span class="find-my-size-page__status-dot" aria-hidden="true"></span>' +
          '<span class="find-my-size-page__status-text">Searching "' + escapeHtml(displayKeywordQuery) + '" in size <span class="find-my-size-page__status-size">' + escapeHtml(prettySize) + '</span></span>' +
        '</span>';
      }

      return '<span class="find-my-size-page__status-line">' +
        '<span class="find-my-size-page__status-dot" aria-hidden="true"></span>' +
        '<span class="find-my-size-page__status-text">Available now in size <span class="find-my-size-page__status-size">' + escapeHtml(prettySize) + '</span></span>' +
      '</span>';
    }

    function renderResultsForItems(sizeKey, displayItems) {
      var totalCount = displayItems.length;
      var keywords = getActiveKeywords();
      var filteredItems = keywords.length
        ? displayItems.filter(function (item) { return itemMatchesKeywords(item, keywords); })
        : displayItems.slice();

      if (!filteredItems.length) {
        updateHeaderSummary(sizeKey, 0);
        clearResultsBusyState();
        results.innerHTML = '<div class="find-my-size-page__empty"><p>No styles in <strong>' + escapeHtml(prettifySize(sizeKey)) + '</strong> matched <strong>"' + escapeHtml(getDisplayKeywordQuery()) + '"</strong>. Try another style keyword.</p></div>';
        status.innerHTML = renderStatusMarkup(sizeKey, 0, totalCount);
        return;
      }

      var html = ['<div class="find-my-size-page__grid">'];
      filteredItems.forEach(function (item) {
        var hasCompareAtPrice = item.compareAtPrice && Number(item.compareAtPrice) > Number(item.price || 0);
        var priceMarkup = '<p class="find-my-size-card__price">' +
          (hasCompareAtPrice ? '<span class="find-my-size-card__compare-price">' + escapeHtml(formatMoney(item.compareAtPrice)) + '</span>' : '') +
          '<span class="find-my-size-card__sale-price">' + escapeHtml(formatMoney(item.price)) + '</span>' +
        '</p>';
        html.push(
            '<article class="find-my-size-card">' +
              (item.image
              ? '<a class="find-my-size-card__media" href="' + escapeHtml(item.url) + '" aria-label="' + escapeHtml(item.title) + '"><img src="' + escapeHtml(item.image) + '"' + srcsetAttribute(item.image) + ' alt="' + escapeHtml(item.title) + '" width="360" height="360" loading="lazy" decoding="async" fetchpriority="low"></a>'
              : '') +
            '<div class="find-my-size-card__body">' +
              (item.isPreorder ? '<span class="find-my-size-card__badge">Pre-order</span>' : '') +
              '<h2 class="find-my-size-card__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h2>' +
              '<p class="find-my-size-page__meta">' + (item.color ? escapeHtml(item.color) : '') + '</p>' +
              priceMarkup +
              '<div class="find-my-size-card__actions">' +
                '<form method="post" action="/cart/add">' +
                  '<input type="hidden" name="id" value="' + escapeHtml(item.variantId) + '">' +
                  '<input type="hidden" name="properties[_preorder]" value="' + (item.isPreorder ? 'true' : '') + '">' +
                  '<input type="hidden" name="properties[_preorder_eta]" value="' + (item.isPreorder ? '10-14 days' : '') + '">' +
                  '<button type="submit" class="btn' + (item.isPreorder ? ' find-my-size-card__cta--preorder' : '') + '" data-find-my-size-cart-submit data-loading-label="' + escapeHtml(item.isPreorder ? 'Pre-ordering…' : 'Adding…') + '">' +
                    '<span class="find-my-size-card__cta-label">' + escapeHtml(item.isPreorder ? 'Pre-order' : (config.buttonLabel || 'Add to cart')) + '</span>' +
                    '<span class="find-my-size-card__cta-loading" aria-hidden="true"></span>' +
                  '</button>' +
                '</form>' +
              '</div>' +
            '</div>' +
          '</article>'
        );
      });
      html.push('</div>');
      updateHeaderSummary(sizeKey, filteredItems.length);
      clearResultsBusyState();
      results.innerHTML = html.join('');
      status.innerHTML = '';
      status.hidden = true;
    }

    function clearResultsBusyState() {
      results.removeAttribute('aria-busy');
    }

    function renderLoadingState(sizeKey, itemCount) {
      var prettySize = prettifySize(sizeKey);
      var skeletonCount = Math.max(4, Math.min(parseInt(itemCount, 10) || 4, 8));
      var html = ['<div class="find-my-size-page__grid find-my-size-page__grid--loading" aria-hidden="true">'];

      for (var index = 0; index < skeletonCount; index += 1) {
        html.push(
          '<article class="find-my-size-card find-my-size-card--loading">' +
            '<div class="find-my-size-card__media find-my-size-card__media--loading"></div>' +
            '<div class="find-my-size-card__body">' +
              '<div class="find-my-size-card__skeleton-block find-my-size-card__title--loading"></div>' +
              '<div class="find-my-size-card__skeleton-block find-my-size-card__meta--loading"></div>' +
              '<div class="find-my-size-card__skeleton-block find-my-size-card__variant--loading"></div>' +
              '<div class="find-my-size-card__skeleton-block find-my-size-card__price--loading"></div>' +
              '<div class="find-my-size-card__skeleton-block find-my-size-card__cta--loading"></div>' +
            '</div>' +
          '</article>'
        );
      }

      html.push('</div>');
      results.setAttribute('aria-busy', 'true');
      results.innerHTML = html.join('');
      updateHeaderSummary(sizeKey, itemCount);
      status.hidden = false;
      status.innerHTML = '<span class="find-my-size-page__status-line find-my-size-page__status-line--loading"><span class="find-my-size-page__status-dot" aria-hidden="true"></span><span class="find-my-size-page__status-text">Checking availability in size <span class="find-my-size-page__status-size">' + escapeHtml(prettySize) + '</span>...</span></span>';
    }

    function mergeHydratedItems(baseItems, hydratedItems) {
      var hydratedByVariantId = {};

      hydratedItems.forEach(function (item) {
        if (item && item.variantId != null) hydratedByVariantId[String(item.variantId)] = item;
      });

      return baseItems.map(function (item) {
        var hydratedItem = item && item.variantId != null ? hydratedByVariantId[String(item.variantId)] : null;
        return hydratedItem || item;
      });
    }

    function scheduleHydrationTask(callback) {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(callback, { timeout: 1200 });
        return;
      }

      window.setTimeout(callback, 150);
    }

    function hydrateRemainingItems(sizeKey, runId, startIndex) {
      var currentItems = state.itemsBySize[sizeKey] || [];
      var remainingItems = currentItems.slice(startIndex);
      if (!remainingItems.length) return;

      scheduleHydrationTask(function () {
        hydrateItemsForDisplay(remainingItems).then(function (hydratedItems) {
          if (state.selectedSize !== sizeKey || state.hydrationRunId !== runId) return;
          state.itemsBySize[sizeKey] = mergeHydratedItems(state.itemsBySize[sizeKey] || [], hydratedItems);
          renderResultsForItems(sizeKey, state.itemsBySize[sizeKey]);
        }).catch(function () {});
      });
    }

    function renderItems(sizeKey) {
      var items = state.itemsBySize[sizeKey] || [];
      var runId = ++state.hydrationRunId;
      if (!items.length) {
        updateHeaderSummary(sizeKey, 0);
        status.hidden = false;
        clearResultsBusyState();
        results.innerHTML = '<div class="find-my-size-page__empty"><p>' + escapeHtml(config.emptyMessage || 'No products are available in that size right now.') + '</p></div>';
        status.textContent = config.emptyMessage || 'No products are available in that size right now.';
        return;
      }

      renderResultsForItems(sizeKey, items);

      if (items.every(function (item) { return item.inventoryKnown; })) return;

      hydrateItemsForDisplay(items.slice(0, initialHydrationItemLimit)).then(function (displayItems) {
        if (state.selectedSize !== sizeKey || state.hydrationRunId !== runId) return;
        state.itemsBySize[sizeKey] = mergeHydratedItems(state.itemsBySize[sizeKey] || items, displayItems);
        renderResultsForItems(sizeKey, state.itemsBySize[sizeKey]);
        hydrateRemainingItems(sizeKey, runId, initialHydrationItemLimit);
      }).catch(function () {
        if (state.selectedSize !== sizeKey || state.hydrationRunId !== runId) return;
        renderResultsForItems(sizeKey, items);
        hydrateRemainingItems(sizeKey, runId, initialHydrationItemLimit);
      });
    }

    function setSelectedSize(sizeKey) {
      state.selectedSize = sizeKey || '';
      if (selectWrap) {
        selectWrap.classList.toggle('has-selection', !!state.selectedSize);
      }
      updateGuideForSelection();
      if (!state.selectedSize) {
        updateHeaderSummary('', 0);
      }
      resetButton.hidden = !state.selectedSize;
      if (shareButton) shareButton.hidden = !state.selectedSize;
      if (keywordWrap) keywordWrap.hidden = !state.selectedSize;
      if (!state.selectedSize) {
        setKeywordState('');
      }
      updateQueryParam(state.selectedSize, state.keywordQuery);
    }

    function renderInitialState(message) {
      updateHeaderSummary('', 0);
      status.hidden = false;
      status.textContent = message;
      clearResultsBusyState();
      results.innerHTML = '<div class="find-my-size-page__empty"><p>' + escapeHtml(message) + '</p></div>';
    }

    function resetCartSubmitButton(button) {
      var label = button.querySelector('.find-my-size-card__cta-label');
      var originalLabel = button.getAttribute('data-original-label');

      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;

      if (label && originalLabel) {
        label.textContent = originalLabel;
      }
    }

    function setCartSubmitButtonLoading(button) {
      var label = button.querySelector('.find-my-size-card__cta-label');
      var loadingLabel = button.getAttribute('data-loading-label') || 'ADDING...';

      if (label && !button.getAttribute('data-original-label')) {
        button.setAttribute('data-original-label', label.textContent);
      }

      if (label) {
        label.textContent = loadingLabel;
      }

      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;

      window.setTimeout(function () {
        if (button.classList.contains('is-loading')) {
          resetCartSubmitButton(button);
        }
      }, 8000);
    }

    function fetchProductsFromCompactIndex() {
      var page = 1;
      var allProducts = [];
      var url = buildCollectionIndexUrl(page);

      if (!url) {
        return Promise.reject(new Error('Missing collection handle or path'));
      }

      function next() {
        return fetchWithTimeout(buildCollectionIndexUrl(page), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            return response.json();
          })
          .then(function (payload) {
            var products = payload && payload.products ? payload.products : [];
            allProducts = allProducts.concat(products);
            if (payload && payload.has_more) {
              page += 1;
              return next();
            }
            writeCachedProducts(allProducts);
            return allProducts;
          });
      }

      return next();
    }

    function fetchProductsFromJsonEndpoint() {
      var page = 1;
      var allProducts = [];
      var url = buildCollectionUrl(page);

      if (!url) {
        return Promise.reject(new Error('Missing collection handle or path'));
      }

      function next() {
        return fetchWithTimeout(buildCollectionUrl(page), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            return response.json();
          })
          .then(function (payload) {
            var products = payload && payload.products ? payload.products : [];
            allProducts = allProducts.concat(products);
            if (products.length === pageSize) {
              page += 1;
              return next();
            }
            writeCachedProducts(allProducts);
            return allProducts;
          });
      }

      return next();
    }

    function fetchAllProducts() {
      var cachedProducts = readCachedProducts();
      if (cachedProducts) return Promise.resolve(cachedProducts);

      return fetchProductsFromCompactIndex().catch(function () {
        return fetchProductsFromJsonEndpoint();
      });
    }

    select.addEventListener('change', function (event) {
      var sizeKey = event.target.value;
      if (!sizeKey) {
        setSelectedSize('');
        renderInitialState('Choose a size to see what is available.');
        return;
      }
      setSelectedSize(sizeKey);
      renderItems(sizeKey);
    });

    results.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.getAttribute('action') !== '/cart/add') return;

      var submitButton = form.querySelector('[data-find-my-size-cart-submit]');
      if (!submitButton) return;

      if (submitButton.classList.contains('is-loading')) {
        event.preventDefault();
        return;
      }

      setCartSubmitButtonLoading(submitButton);

      // Add in place and open the cart drawer, as the product page does, so the shopper keeps their size
      // results. Without fetch or the modern cart (mstore-modern-core.js) the native POST to /cart/add
      // still runs, and any failure falls back to it too.
      if (!window.fetch || !window.MStoreCart) return;
      event.preventDefault();
      addToCartInPlace(form, submitButton);
    }, true);

    function addToCartInPlace(form, button) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var variantId = Number(form.querySelector('input[name="id"]').value);
      var addLine = function () {
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed: ' + response.status);
            return fetch(root + 'cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) { return { cart: cart }; });
      };
      var standard = window.MStoreStandardEvents;
      var run = standard
        ? standard.cartLinesUpdate(form, { action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], run: addLine })
        : addLine();

      Promise.resolve(run).then(function () {
        resetCartSubmitButton(button);
        document.dispatchEvent(new CustomEvent('mstore:cart-updated'));
      }).catch(function (error) {
        console.error(error);
        resetCartSubmitButton(button);
        HTMLFormElement.prototype.submit.call(form);
      });
    }

    if (keywordInput) {
      ['keydown', 'keypress', 'keyup'].forEach(function (eventName) {
        keywordInput.addEventListener(eventName, function (event) {
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          } else {
            event.stopPropagation();
          }
        }, true);
      });

      keywordInput.addEventListener('keydown', function (event) {
        var isSpaceKey = event.key === ' ' || event.key === 'Spacebar' || event.code === 'Space';
        if (!isSpaceKey) return;

        event.preventDefault();

        var inputValue = keywordInput.value || '';
        var selectionStart = typeof keywordInput.selectionStart === 'number' ? keywordInput.selectionStart : inputValue.length;
        var selectionEnd = typeof keywordInput.selectionEnd === 'number' ? keywordInput.selectionEnd : selectionStart;
        var nextValue = inputValue.slice(0, selectionStart) + ' ' + inputValue.slice(selectionEnd);
        var nextCursor = selectionStart + 1;

        setKeywordState(nextValue);

        if (typeof keywordInput.setSelectionRange === 'function') {
          requestAnimationFrame(function () {
            keywordInput.setSelectionRange(nextCursor, nextCursor);
          });
        }

        if (!state.selectedSize) return;
        renderResultsForItems(state.selectedSize, state.itemsBySize[state.selectedSize] || []);
      });

      keywordInput.addEventListener('input', function (event) {
        setKeywordState(event.target.value);
        if (!state.selectedSize) return;
        renderResultsForItems(state.selectedSize, state.itemsBySize[state.selectedSize] || []);
      });
    }

    if (keywordClear) {
      keywordClear.addEventListener('click', function () {
        setKeywordState('');
        if (keywordInput) keywordInput.focus();
        if (!state.selectedSize) return;
        renderResultsForItems(state.selectedSize, state.itemsBySize[state.selectedSize] || []);
      });
    }

    if (guideToggle) {
      guideToggle.addEventListener('click', function () {
        var shouldExpand = guide ? guide.hidden : false;
        setGuideExpanded(shouldExpand, shouldExpand);
      });
    }

    resetButton.addEventListener('click', function () {
      select.value = '';
      setSelectedSize('');
      renderInitialState('Choose a size to see what is available.');
      select.focus();
    });

    if (shareButton) {
      shareButton.addEventListener('click', function () {
        if (!state.selectedSize) return;
        var shareUrl = getShareUrl(state.selectedSize, state.keywordQuery);
        var activeQuery = getDisplayKeywordQuery();

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(function () {
            setShareButtonState(true);
            status.textContent = activeQuery
              ? 'Share link copied for size ' + prettifySize(state.selectedSize) + ' and "' + activeQuery + '".'
              : 'Share link copied for size ' + prettifySize(state.selectedSize) + '.';
          }).catch(function () {
            status.textContent = 'Copy failed. You can still use this link: ' + shareUrl;
          });
          return;
        }

        status.textContent = 'Copy failed. You can still use this link: ' + shareUrl;
      });
    }

    renderInitialState('Loading available sizes...');

    fetchAllProducts()
      .then(function (products) {
        collectItems(products || []);
        renderSizeOptions();
        state.loaded = true;

        if (!state.sizes.length) {
          renderInitialState(config.emptyMessage || 'No products are available right now.');
          return;
        }

        renderInitialState('Choose a size to see what is available.');
        applyQueryParams();
      })
      .catch(function () {
        select.innerHTML = '<option value="">Unavailable</option>';
        select.disabled = true;
        renderInitialState(config.errorMessage || 'We could not load sizes right now. Please try again in a moment.');
      });
  })();
